module.exports = __webpack_public_path__ + "img/rotate-cw.7909af82.svg";